export default "__VITE_ASSET__B9G4GiGw__"